module.exports = __webpack_public_path__ + "static/hvik_tommi_8-ea3eece72f7bb2c987cabb748e3ace81.jpg";